export const DEBUG = {
    OVERLAY: false,
    COURT: true,
    GAZE: false,
    BBOX: false,
    LINE: false,
    ATTENTIONS: false,
    TIMELINE: true,
    MOUSE_GAZE: true,
    DEBUG_MEM: false
}